class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
      if (typeof infinitescroll == 'object' && typeof infinitescroll?.scolljs == 'function') {
        infinitescroll?.scolljs();
      }
    }, 500);
    if($(window).width() < 992){
      // const applyfilter = this.querySelector('.apply-filter');
      // if (applyfilter) {
      //   applyfilter.addEventListener('click', (event) => {
      //     this.debouncedOnSubmit(event);
      //     this.resetInfiniteScroll();
      //     window.location.reload(); // Reload the page if the form has been submitted
      //   });
      // }
      this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
      this.querySelector('form').addEventListener('input', hidesubcate);
     }else{
      this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
     }  
      //const applyfilter = this.querySelector('.apply-filter');
      //if (applyfilter) applyfilter.addEventListener('click', this.debouncedOnSubmit.bind(this));    
    const sortbtn = this.querySelector('.sort-button');
    if(document.querySelector('.sort-box')){
      this.querySelector('.sort-box').addEventListener('input', this.debouncedOnSubmit.bind(this));
    }
  }
  static setListeners() {
      const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);   
  }
  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
      FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }
  static renderSectionFromFetch(url, event) {
    fetch(url)
    .then(response => response.text())
    .then((responseText) => {
      const html = responseText;
      FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.renderActiveFilter(html);
      typeof infinitescroll == 'object' && typeof infinitescroll?.scolljs == 'function' && infinitescroll?.scolljs();
      next_Collection();
      var collection_count2 = $(html).find('.count-collectionitem').html();
      $('.count-collectionitem').html('');
      $('.count-collectionitem').html(collection_count2);
      $(".grid-meta").matchHeight({property:"height"});
      var uls = document.querySelectorAll('.grid-colorlist.grid_clr');

    uls.forEach((ul) => {
        var activeLi = ul.querySelector('li.active');

        if (activeLi) {
            ul.insertBefore(activeLi, ul.firstChild);
        }
    });
      // console.log("fetxh");
      updateProductCardsWithColorVariantDataOnHover();
      updateDesktopProductCards();
      initCollectionGridToggle();
      availablelist();
      hidesubcate();
      // hidebanner();
      // combinesamediv();
      
      // Ensure all dropdowns remain closed after filtering
      $('.filter-droplist').hide();
      $('.filter-subtitle').removeClass('active');
      
      // Update filter button visibility
      activefilterscls();
    });
    }
      static renderSectionFromCache(filterDataUrl, event) {
      const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.renderActiveFilter(html);
      var collection_count2 = $(html).find('.count-collectionitem').html();
      $('.count-collectionitem').html('');
      $('.count-collectionitem').html(collection_count2);
      $(".grid-meta").matchHeight({property:"height"});
        console.log("cache");
      updateProductCardsWithColorVariantDataOnHover();
      // initCollectionGridToggle();
      updateDesktopProductCards();
      availablelist();
      hidesubcate();
      // hidebanner();
      // combinesamediv();
      
      // Ensure all dropdowns remain closed after filtering
      $('.filter-droplist').hide();
      $('.filter-subtitle').removeClass('active');
      
      // Update filter button visibility
      activefilterscls();
    }
      static renderProductGridContainer(html) {
      document.getElementById('collection-grid').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('collection-grid').innerHTML;
      // if($(window).width() > 992){
      //   if($('.availability_input').length > 0){
      //       var ActiveFilterCount = Number($('.collection-grid').attr('data-filterscount'));
      //       if(ActiveFilterCount > 0){
      //         if($('.availability_input').prop('checked') == true){
      //         }else{
      //           $('.availability_input').trigger('click');
      //         }
      //       }else{
      //         if($('.availability_input').prop('checked') == true){
      //           $('.availability_input').trigger('click');
      //         }else{
                
      //         }
      //       }
      //   }
      // }  
    }
      static renderActiveFilter(html) {      
      document.querySelector('.active-facet').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.active-facet').innerHTML;
    }
      static renderFilters(html, event) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const facetDetailsElements =
        parsedHTML.querySelectorAll('.filter-index');
      const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.filter-index') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    facetsToRender.forEach((element) => {
      document.querySelector(`.filter-index[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });
    
    // Ensure all dropdowns are closed after filter rendering
    $('.filter-droplist').hide();
    $('.filter-subtitle').removeClass('active');
  }
  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }
  static getSections() {
    return [
      {
        section: document.getElementById('collection-grid').dataset.id,
      }
    ]
  }

  resetInfiniteScroll() {
    // Reinitialize infinite scroll
    if (window.infinitescroll && window.infinitescroll.endlessScroll) {
      window.infinitescroll.endlessScroll.destroy();
    }

    window.infinitescroll = {
      scolljs: function () {
        window.infinitescroll.endlessScroll = new Ajaxinate({
          container: '#product-grid',
          pagination: '#AjaxinatePagination',
          loadingText: '',
          callback: function() {
            advance();
          },
          offset: 1000
        });
      }
    };
    window.infinitescroll.scolljs();
  }
  
  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData);
    if (searchParams.has('filter.v.option.size')) {
      searchParams.set('filter.v.availability', '1');
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);
    activefilterscls();
  }  
  onActiveFilterClick(event) {
    event.preventDefault();    
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }  
}
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
function availablelist(){
  $('.filter-index').not('.filter-sort').each(function(e){
    var face_eachlist = $(this).find('li').length;
    var active_face_eachlist = $(this).find('li').not('.disable-facet').length;    
    if(active_face_eachlist==0){
      $(this).hide();
    }else{
      $(this).show();
    }
  });  
}
function hidesubcate(){
  if($('[data-type="category"]').closest('.all-accessories').length < 1){
    var n = $('[data-type="category"]').find("input:checked").length;
         console.log(n)
      if(n>0){
        $('[data-type="subcategory"]').show();
      }
      else{
        $('[data-type="subcategory"]').hide();
        $('[data-type="subcategory"]').find("input:checked").each(function(params) {
        $(this).prop('checked',false);
        const formElement = document.querySelector('facet-filters-form form');
        
        // Create a new InputEvent
        const inputEvent = new InputEvent('input', {
        bubbles: true, 
        cancelable: true,
        });
        
        formElement.dispatchEvent(inputEvent);
        })
      }
    }
}
availablelist();
$('.facet-list').each(function(e){
  var checked_val = $(this).find($('input[type="checkbox"]:checked')).length;
  if(checked_val>0){
    $(this).closest('.facet-list').addClass('selected-list');
  }else{
    $(this).closest('.facet-list').removeClass('selected-list');
  }
});
function filterprice(){
  var inputLeft = document.querySelector(".price-left");
  var inputRight = document.querySelector(".price-right");
  var amountLeft = document.querySelector(".amount-left .amount-percentage");
  var amountRight = document.querySelector(".amount-right .amount-percentage");
  var thumbLeft = document.querySelector(".price-slider > .thumb.left");
  var thumbRight = document.querySelector(".price-slider > .thumb.right");
  var range = document.querySelector(".price-slider > .range");
  function setLeftValue() {
    var _this = inputLeft,
        min = parseInt(_this.min),
        max = parseInt(_this.max);
    _this.value = Math.min(parseInt(_this.value), parseInt(inputRight.value) - 1);
    var percent = ((_this.value - min) / (max - min)) * 100;
    thumbLeft.style.left = percent + "%";
    amountLeft.innerHTML = _this.value;
    $('.textpriceleft').val(_this.value);
    range.style.left = percent + "%";
  }
  setLeftValue();
  function setRightValue() {
    var _this = inputRight,
        min = parseInt(_this.min),
        max = parseInt(_this.max);
    _this.value = Math.max(parseInt(_this.value), parseInt(inputLeft.value) + 1);
    var percent = ((_this.value - min) / (max - min)) * 100;
    thumbRight.style.right = (100 - percent) + "%";
    amountRight.innerHTML = _this.value;
    $('.textpriceright').val(_this.value);
    range.style.right = (100 - percent) + "%";
    _this.style.zIndex  = 3;
  }
  setRightValue();
  inputLeft.addEventListener("input", setLeftValue);
  inputRight.addEventListener("input", setRightValue);
  $('.textpriceleft').on("change",function(e){
    $('.price-left').val($(this).val());       
    var _this = inputLeft,
        min = parseInt(_this.min),
        max = parseInt(_this.max);
    _this.value = Math.min(parseInt(_this.value), parseInt(inputRight.value) - 1);
    var percent = ((_this.value - min) / (max - min)) * 100;    
    thumbLeft.style.left = percent + "%";
    range.style.left = percent + "%";
    if($(this).val().length == 0){
      $(this).val($(this).attr('min'));
      thumbLeft.style.left = 0+'%';
      range.style.left = 0+ "%";
      $('.price-left').val(0);  
    }
  });
  $('.textpriceright').on("change",function(e){
    $('.price-right').val($(this).val());
    //setRightValue();
    var _this = inputRight,
        min = parseInt(_this.min),
        max = parseInt(_this.max);
    _this.value = Math.max(parseInt(_this.value), parseInt(inputLeft.value) + 1);
    var percent = ((_this.value - min) / (max - min)) * 100;
    thumbRight.style.right = (100 - percent) + "%";
    range.style.right = (100 - percent) + "%";
    _this.style.zIndex  = 3;
    if($(this).val().length == 0){
      $(this).val(Math.round($(this).attr('max')));
      thumbRight.style.right = 0+'%';
      range.style.right = 0+ "%";
      $('.price-right').val(Math.round($(this).attr('max')));      
    }
  });
}
if(document.querySelector('.range-wrap')){
  filterprice();
}
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function fnBrowserDetect(){
  let userAgent = navigator.userAgent;
  let browserName;
  if(userAgent.match(/chrome|chromium|crios/i)){
    browserName = "chrome";
  }else if(userAgent.match(/firefox|fxios/i)){
    browserName = "firefox";
  }  else if(userAgent.match(/safari/i)){
    browserName = "safari";
  }else if(userAgent.match(/opr\//i)){
    browserName = "opera";
  } else if(userAgent.match(/edg/i)){
    browserName = "edge";
  }else{
    browserName="no-browser";
  }
  document.getElementById('MainContent').classList.add(browserName);
}
fnBrowserDetect()
$(document).on('click','.filter-subtitle',function(e){
  e.preventDefault();
  $(this).next('.filter-droplist').slideToggle();
  $(this).toggleClass('active');
});
function collectionscroll(){
  var collsticky_position = $('.collection-header').offset().top;
  $(window).scroll(function(){
    if ($(window).scrollTop() > collsticky_position) {
      // $('.collection-header').addClass('sticky-collection');
      $('.fixed-filter-button').addClass('sticky-collection');
      
    }
    else {
      $('.fixed-filter-button').removeClass('sticky-collection');
      // $('.collection-header').removeClass('sticky-collection');
    }
    var cp_docViewTop = $(window).scrollTop();
    var cp_docViewBottom = cp_docViewTop + $(window).height();
    var cp_elemTop = $('.section-footer').offset().top;
    if(cp_elemTop < cp_docViewBottom){
      $('.collection-header').addClass('addCSticky');
    }else{
      $('.collection-header').removeClass('addCSticky');
    }
  });  
}
collectionscroll();
function activefilterscls(){
  $('.facet-list').each(function(e){
    var checked_val = $(this).find($('input[type="checkbox"]:checked')).length;
    if(checked_val>0){
      $(this).closest('.facet-list').addClass('selected-list');
    }else{
      $(this).closest('.facet-list').removeClass('selected-list');
    }
  });
  
  // Check if any filters are selected and show/hide clear button accordingly
  if($('.filter-index.selected-list').length>0){
    $('.apply-filter,.filter-button').addClass('active');
    $('.clear-filters-desktop').addClass('d-lg-block');
  }else{
    $('.apply-filter,.filter-button').removeClass('active');
    setTimeout(() => {
      $('.clear-filters-desktop').removeClass('d-lg-block');
    }, 200);
  }  
}
activefilterscls();
$(document).on('click','.filter-button',function(e){
  e.preventDefault();
  $('body').toggleClass('open-filter');
  activefilterscls();
  $(".grid-meta").matchHeight({property:"height"});
});
$(document).on('click','.active-filters__remove-filter',function(event){
  event.preventDefault();
  const form = document.querySelector('facet-filters-form');
  form.onActiveFilterClick(event);
  setTimeout(function(){ 
    activefilterscls();
  }, 3000);
});
$(document).on('click','.clear-filter',function(event){
  event.preventDefault();
  const form = document.querySelector('facet-filters-form');
  form.onActiveFilterClick(event);
  setTimeout(function(){ 
    activefilterscls();
  }, 800);
  if($(window).width()<992){
  window.location.reload();
  }
});
$(document).on('click','.apply-filter,.close-coll-filter,.clear-filter',function(e){
  e.preventDefault();
  console.log("clickkked")
  $('body').removeClass('open-filter');
  //$('.filter-subtitle').addClass('active');
});

if($(window).width()<992){
  //$('.filter-subtitle').addClass('active');
  $('.filter-subtitle').on('click',function(e){    
    $(this).closest('.facet-list').siblings().find('.filter-droplist').slideUp();
    $(this).closest('.facet-list').siblings().find('.filter-subtitle ').removeClass('active');
  });
  if($('.filter-index.selected-list').length>0){
    $('.apply-filter').addClass('active');
  }else{
    $('.apply-filter').removeClass('active');
  }
}
$('body').on('click',function(e){   
  var filterbox = $(".filter-button,.result-filter");    
  if (!filterbox.is(e.target) && filterbox.has(e.target).length === 0){
    $('body').removeClass('open-filter');
  }
});

// Combine the existing document.ready with our modifications
$(document).ready(function() {
  // Ensure all filter dropdowns are closed by default (for both mobile and desktop)
  $('.filter-droplist').hide();
  $('.filter-subtitle').removeClass('active');
  
  // Original document.ready functionality
  hidesubcate();
})
function combinesamediv(){
  // Assuming you already have window.tagarray defined
window.tagarray = [
  'fw23', 'ss23', 'fw22', 'ss22', 
  'fw21', 'ss21', 'fw20', 'ss20', 
  'classics', 'collabs'
];

// Loop through each tag in the array and call the function
// window.tagarray.forEach(function(tag) {
//   // Here we're passing the tag after stripping it (like your Liquid code does)
//   wrapElementsByClass(tag.trim()); // Call the function with the current tag
// });

}